export enum DefaultPackageConfigurationFieldsType {
  Dimensions = "Dimensions",
  Weight = "Weight",
  Labels = "Labels",
  Barcode = "Barcode",
  Spot = "Spot",
  Description = "Description",
  Value = "Value",
  SKU = "SKU",
  Pallets = "Pallets"
}
